
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog, faSave, faTimes } from "@fortawesome/free-solid-svg-icons";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { InputGroup, Button } from "react-bootstrap";
import Swal from "sweetalert2";
// import Input from "./Components/Input";
import { convEstadoService } from "../../../_services/convEstado.service";
import { Tabla } from "../../../components/Table/Table";
import TooltipText from "../../../components/TooltipText";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../../redux/Loading/actions";
import { Form } from "react-bootstrap";
import EvaluacionesConfig from "./Components/EvaluacionesConfig";
import { FileText, Settings } from "react-feather";
import { RealizarEvaluaciones } from "./Components/RealizarEvaluaciones";
import { getAbogados } from "../../../redux/Sections/Abogados/actions";
import ArrowBack from "../../../components/ArrowBack";

const Honorarios = () => {
  const dispatch = useDispatch();
  const { abogadosList } = useSelector(e => e.dashboard);

  const [data, setData] = useState([]);
  const [edit, setEdit] = useState("");

  const getData = async () => {
    dispatch(setLoading(true));
    let res = await convEstadoService.getConvEstado();

    setData(res);
    dispatch(setLoading(false));
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    dispatch(getAbogados());
  }, []);

  const columns = [
    {
      title: "Nombre",
      dataIndex: "nombre",
    },
    {
      title: "Hon.s/Deuda",
      dataIndex: "porcentual",
      width: 200
    },
    {
      title: "Gasto fijo",
      dataIndex: "gastofijo",
      width: 200
    },
    {
      title: "Bono ley",
      dataIndex: "jus",
      width: 200
    },
    {
      title: "Acción",
      dataIndex: "accion",
    },
  ];

  const handleSave = (data) => {
    Swal.fire({
      title: "¿Esta seguro de guardar los cambios?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch(setLoading(true));

        let response = await convEstadoService.saveConvEstado(data);

        dispatch(setLoading(false));

        if (response.ok) {
          return Swal.fire({
            title: "Exito!",
            text: "Los datos es guardaron correctamente.",
            icon: "success",
            willClose: () => {
              setEdit("");
              getData();
            }
          });
        }
        else {
          dispatch(setLoading(false));
          return Swal.fire(
            "Error!",
            response.error || "Ocurrio un error, intentelo nuevamente.",
            "error"
          );
        }
      }
    });
  };

  const handleEdit = (item) => {
    setEdit(item.id);
  };

  const handleCancel = () => {
    setEdit("");
  };


  const formatData = (arrayData) => {
    try {
      return arrayData.map(item => {
        let porcentual = item.porcentual;
        let gastofijo = item.gastofijo;
        let jus = item.jus;

        return {
          ...item,
          porcentual: (
            <InputGroup className="mb-2">
              <InputGroup.Prepend>
                <InputGroup.Text>%</InputGroup.Text>
              </InputGroup.Prepend>
              {item.id === edit ? (
                <Form.Control
                  type="number"
                  name="porcentual"
                  key={`porcentual-${item.id}`}
                  defaultValue={porcentual}
                  onChange={(e) => {
                    return porcentual = +e.target.value;
                  }}
                  style={{ minWidth: 100, maxWidth: 110 }}
                />
              ) : (
                <Form.Control
                  type="number"
                  name="porcentual"
                  key={`porcentual-disabled-${item.id}`}
                  value={item.porcentual}
                  style={{ minWidth: 100, maxWidth: 110 }}
                  disabled
                />
              )}
            </InputGroup>
          ),
          gastofijo: (
            <InputGroup className="mb-2">
              <InputGroup.Prepend>
                <InputGroup.Text>%</InputGroup.Text>
              </InputGroup.Prepend>
              {item.id === edit ? (
                <Form.Control
                  type="number"
                  name="gastofijo"
                  key={`gastofijo-${item.id}`}
                  defaultValue={gastofijo}
                  onChange={(e) => {
                    return gastofijo = +e.target.value;
                  }}
                  style={{ minWidth: 100, maxWidth: 110 }}
                />
              ) : (
                <Form.Control
                  type="number"
                  name="gastofijo"
                  key={`gastofijo-disabled-${item.id}`}
                  value={item.gastofijo}
                  style={{ minWidth: 100, maxWidth: 110 }}
                  disabled
                />
              )}
            </InputGroup>
          ),
          jus: (
            <InputGroup className="mb-2">
              <InputGroup.Prepend>
                <InputGroup.Text>$</InputGroup.Text>
              </InputGroup.Prepend>
              {item.id === edit ? (
                <Form.Control
                  type="number"
                  name="jus"
                  key={`jus-${item.id}`}
                  defaultValue={jus}
                  onChange={(e) => {
                    return jus = +e.target.value;
                  }}
                  style={{ minWidth: 100, maxWidth: 110 }}
                />
              ) : (
                <Form.Control
                  type="number"
                  name="jus"
                  key={`jus-disabled-${item.id}`}
                  value={+item.jus}
                  style={{ minWidth: 100, maxWidth: 110 }}
                  disabled
                />
              )}
            </InputGroup>
          ),
          accion: (
            <div className="d-flex">
              {item.id !== edit ? (
                <Button
                  className="d-flex align-items-center ml-2"
                  variant="contained"
                  onClick={() => handleEdit(item)}
                >
                  <FontAwesomeIcon icon={faEdit} size="lg" className="mr-3" color="gray" />
                </Button>
              ) : (
                <>
                  <TooltipText placement="top" text="Guardar valores" >
                    <Button
                      className="d-flex align-items-center ml-2"
                      variant="contained"
                      onClick={() => handleSave({ ...item, porcentual, jus, gastofijo })}
                    >
                      <FontAwesomeIcon icon={faSave} size="lg" className="mr-3" color="#006699" />
                    </Button>
                  </TooltipText>
                  <Button
                    className="d-flex align-items-center ml-2"
                    variant="contained"
                    onClick={() => handleCancel(item)}
                  >
                    <FontAwesomeIcon icon={faTimes} size="lg" className="mr-3" color="red" />
                  </Button>
                </>
              )}
            </div>)
        };
      });
    }
    catch (err) {
      console.log(err);
      return [];
    }
  };


  return (
    <div className="section-content">
      <ArrowBack />

      <div className="section-title d-flex align-items-center mt-4">
        <FontAwesomeIcon icon={faCog} style={{ fontSize: 34, color: "#999999" }} />
        <span>Honorarios</span>
      </div>
      <Tabla dataList={formatData(data)} columns={columns} />

      <br />

      <div className="section-title d-flex align-items-center mt-4">
        <Settings icon={faCog} style={{ fontSize: 34, color: "#999999" }} />
        <span>Evaluaciones</span>
      </div>
      <EvaluacionesConfig />

      <br />

      <div className="section-title d-flex align-items-center mt-4">
        <FileText icon={faCog} style={{ fontSize: 34, color: "#999999" }} />
        <span>Realizar Evaluaciones</span>
      </div>
      <RealizarEvaluaciones abogados={abogadosList} />
    </div>
  );
};


export default Honorarios;